//Sector/Indust  components

import React from "react";

import reqwest from "reqwest";
import { Slider, Row, Col, Card, Select, Button, TreeSelect,Tag,Popover,Tooltip } from "antd";
import { connect } from "react-redux";
import { activateDatadic,activateDatadicbackup,activateFiname,activateChange,activateScreen,activateRecord,activatePath,activateGoing , activateUnivid,
  activateUnivtype,  } from "../redux";
import { CloseCircleTwoTone, PoweroffOutlined } from "@ant-design/icons";

const { Option } = Select;
const { SHOW_PARENT } = TreeSelect;

class DropdownTreeClass extends React.Component {
  constructor(props) {
    super(props);
    window.indst = []
    this.myRef = React.createRef();
    this.state = {
      pass: this.props.pass,
      id: this.props.id,
      data: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
  
    this.props.activateChange(1);
    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].value = e;
    setTimeout(() =>  this.HandleReqcount(), 1*1000);
   
  }

/*   enterClose(e) {
    
    this.props.activateChange(1);

    this.props.datadic.FilterDic.columns[
      this.myRef.current.props.id
    ].selected = 0;
    this.props.datadic.FilterDic.columns[
      this.myRef.current.props.id
    ].selectedUI = 0;

    this.props.activateDatadic({ FilterDic: this.props.datadic.FilterDic });
    this.HandleReqcount() 
  }
 */
  onChange = (e) => {
  
    this.props.activateChange(1);
    var x = 0;
    var y = 0;
    var x1 = [];
    var y1 = [];

    for (var i = 0; i < e.length; i++) {
      

      if (e[i].length == 2) {
       
        x1[x] = e[i];
        x = x + 1;
      } else {
    
        y1[y] = e[i];
        y = y + 1;
      }
    }

 
   
    if (x1 == "") {
      
      this.props.datadic.FilterDic.columns[0].selected = 0;
    } else {
      this.props.datadic.FilterDic.columns[0].selected = 0;
    }
  
    var xy = x1.concat(y1);

    this.props.datadic.FilterDic.columns[1].value = xy;
    if (y1 == "" && x1 == "") {
       
      this.props.datadic.FilterDic.columns[1].selected = 0;
    } else {
      this.props.datadic.FilterDic.columns[1].selected = 1;
      this.props.datadic.FilterDic.columns[1].selectedUI = 1;
    }
  var ba=""; 
   ba = this.props.datadic.FilterDic.columns[1].value; 
 
 if (ba.length==0){
  this.props.datadic.FilterDic.columns[1].value="";
 }
 
    this.props.activateDatadic({ FilterDic: this.props.datadic.FilterDic });
    setTimeout(() =>  this.HandleReqcount(), 1*1000);
  };
  componentDidMount() {}


/* 
  st2.map((val, i) => {
    console.log(val)
          }); */

          
  trg(id) {
    var inds = [];
    
    this.props.datadic.FilterDic.columns.map((ciiin, i) => {
      if (ciiin.label == "Industry") {
        ciiin.selection.map((ciiin2, i) => {
          if (ciiin2.sectorId == id) {
            
            inds[i] = {
              title:<Tag color="default" > {ciiin2.label}</Tag>,
              value: ciiin2.industryId,
              key: ciiin2.industryId,
            };
            var  val =  this.props.datadic.FilterDic.columns[1].value;
            if (val.includes( ciiin2.industryId)) {
              console.log('arr',window.indst)
              window.indst[i] = {
                title: <Tag color="default" >{ciiin2.label}</Tag>,
                value: ciiin2.industryId,
                key: ciiin2.industryId,
                
              };
            }


          
          }
        });
      }
    });
    
  

    return inds;
  }

  enterClose(e) {
 
    this.props.activateChange(1);
    if (this.state.filtermt==0){
   
      this.props.activateFiname('');


    }
    this.props.datadic.FilterDic.columns[0].value = "";
    this.props.datadic.FilterDic.columns[1].value = "";
    this.props.datadic.FilterDic.columns[0].selected = 0;
    this.props.datadic.FilterDic.columns[0].selectedUI = 0;
    this.props.datadic.FilterDic.columns[1].selected = 0;
    this.props.datadic.FilterDic.columns[1].selectedUI = 0;
    
    this.props.activateDatadic({ FilterDic: this.props.datadic.FilterDic });
    
    setTimeout(() =>  this.HandleReqcount(), 1*1000);
  }


  onDataUpdate = (data) => {
    this.setState(
      {
       
        lookingTickers: false,
      }   )
        this.props.activateRecord(data);
        
        this.props.activateScreen(false);
        this.props.activateGoing(false);
        
    
   
  }
  HandleReqcount() {
   
    this.props.activateScreen(true);
    
    const controller = new AbortController();
    
    const { signal } = controller;
    
   if (this.props.going==false) {
    
    var  requestOptions= '';
    this.props.activateScreen(true);
    if (this.props.univtype==1) {
    
       requestOptions = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({ tables: [this.props.datadic.FilterDic],  portfolioId : this.props.univid   }),
     };
   
    }
    
    if (this.props.univtype==2) {
       requestOptions = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({ tables: [this.props.datadic.FilterDic],  screenId : this.props.univid   }),
     };
   }
 
   if (this.props.univtype==0) {
     requestOptions = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({ tables: [this.props.datadic.FilterDic]    }),
     };
   }
    this.props.activateGoing(true);
    fetch(
      this.props.apppath + "/include/api/screener/ssfiltercount.cfm", 
      requestOptions
    )
      .then((response) => response.json())
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
       this.onDataUpdate(data)
       
      )
      .then((data) => 1)
      .catch((error) => {
         
        this.props.activateScreen(false);
        this.props.activateGoing(false);
        this.setState(
          {
            lookingTickers: false,
          },
          () => {
            this.props.activateRecord("No Results");
          }
        );
      });
    }else{
     
     console.log(this.props.going)
    }
  }

  render() {
    if (this.props.datadic.FilterDic != undefined) {
      var treeData = [];
      var indsSelectedind = [];
      this.props.datadic.FilterDic.columns.map((experience, i) => {
        if (experience.label == "Sector") {
          
       var  val =  this.props.datadic.FilterDic.columns[1].value;
          experience.selection.map((experience2, i) => {
            treeData[i] = {
              title: <Tag color="default" >{experience2.label}</Tag>,
              value: experience2.sectorId,
              key: experience2.sectorId,
              children: this.trg(experience2.sectorId),
            };

     
            
          });
        }
      });

       

    }
     
 

   
    var st = "";
    if (this.props.datadic.FilterDic.columns[0].value != "") {
      st = this.props.datadic.FilterDic.columns[0].value;
    } else {
      st = "";
    }

    var st2 = "";
    if (this.props.datadic.FilterDic.columns[1].value != "") {
      st2 = this.props.datadic.FilterDic.columns[1].value;
        
    } else {
      st2 = "";
    }
    var insecmerge = indsSelectedind.concat( window.indst);
 
   
    const tProps = {
       
      treeData,
      virtual: false,
      showSearch: false,
      value:this.props.datadic.FilterDic.columns[1].value!=''?this.props.datadic.FilterDic.columns[1].value:[],
      onChange: this.onChange,
      treeCheckable: true,
      showCheckedStrategy: SHOW_PARENT,
      placeholder: "Please select",
      style: {
        width: "89%",
      },
    };

    const slidestyle = {
      width: "100%",
    };

    const closebutton = {
      float: "right",
    };


    const gridStyle = {
      //  float: "right",
      width: '100%',
   
        
      };

    let mymax = this.state.pass.max;
    const marks = {
      [this.state.pass.min]: this.state.pass.min,

      [this.state.pass.max]: this.state.pass.max,
    };
    return (
      <div style={slidestyle}>
        <Card>
        <Card.Grid style={gridStyle} className='movercard'>
        <Popover content={this.state.pass.definition} title={this.state.pass.label} placement="right">
          Sector/Industry &nbsp;
          </Popover>
          <Row>
            {" "}
            <Col span={20}></Col>
            <TreeSelect showLine={true} {...tProps} ref={this.myRef} id={this.state.id} />
            <Col span={2} style={{paddingRight: '4px'}}>
              {" "}
              <div style={closebutton}>
                {" "}
                <Tooltip placement="topLeft" title="Remove this filter" color={'#2db7f5'}> <Button
                  type="text"
                  icon={<CloseCircleTwoTone />}
                  onClick={() => this.enterClose(this.state.id)}
                ></Button></Tooltip>{" "}
              </div>{" "}
            </Col>
          </Row>
          </Card.Grid>
        </Card>
      </div>
    );
  }
}
 

const mapStateToProps = (state) => ({
  datadic: state.datadic,
  datadicbackup: state.datadicbackup,
  finame: state.finame,
  change: state.change,
  screen: state.screen,
  record: state.record,
  apppath: state.apppath,
  going: state.going,
  univid: state.univid,
  univtype: state.univtype,
});

const mapDispatchToProps = {
  activateDatadic,activateDatadicbackup,activateFiname,activateChange,activateScreen,activateRecord,activatePath, activateGoing, activateUnivid,
  activateUnivtype, 
};

const DropDwnTr = connect(
  mapStateToProps,
  mapDispatchToProps
)(DropdownTreeClass);

export default DropDwnTr;

 